import {Client, ClientInApp, ClientMeta, FeatureFlags, SubscriptionDetails} from "../types/SubscriptionTypes";

/**
 * Shared utility for parsing client data from DynamoDB format
 * This logic is used by both ClientActiveRecord.mapServerResponseToLocalRow and server-side parsing
 */
export class ClientDataUtils {
    static parseRawClientData(rawClient: Client): ClientInApp {
        return {
            ...rawClient,
            subscription_details: this.parseJsonField<SubscriptionDetails>(rawClient.subscription_details),
            meta: this.parseJsonField<ClientMeta>(rawClient.meta) ?? { quizzesCount: 0, itemsCount: 0, aiUsageCount: 0 },
            feature_flags: this.parseJsonField<FeatureFlags>(rawClient.feature_flags),
        };
    }

    private static parseJsonField<T>(value: string | T | null | undefined): T | undefined {
        if (value === null || value === undefined) {
            return undefined;
        }
        if (typeof value === 'string') {
            if (value.trim().length === 0) {
                return undefined;
            }
            try {
                return JSON.parse(value) as T;
            } catch (error) {
                console.warn('Failed to parse JSON field', error);
                return undefined;
            }
        }
        return value as T;
    }
}
